import React, { useState } from 'react';
import { Alert, Box, TextField } from '@mui/material';

/**
 * ADR-159 §4.1 (C5) — Void Contract body. ONE contract that has not started
 * is voided; the person keeps their other contract(s) and nothing about them
 * changes. Distinct from the person's Hire Withdraw, which voids every
 * not-started contract and makes the person Cancelled.
 */
const EmployeeVoidContract = ({ contractLabel, onValidChange }) => {
  const [reason, setReason] = useState('');
  const [touched, setTouched] = useState(false);

  React.useEffect(() => {
    onValidChange(false, { reason: '' });
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    setReason(value);
    setTouched(true);
    onValidChange(value.trim().length > 0, { reason: value });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
        <Alert severity="warning">
          This <strong>voids {contractLabel || 'this contract'}</strong>: it never takes effect and
          closes on its planned start date. Its pending start, any scheduled end and any scheduled
          replacement are cancelled. The person <strong>keeps their other contract(s)</strong>, and
          nothing else about them changes.
        </Alert>
        <TextField
          fullWidth
          label="Reason"
          value={reason}
          onChange={handleChange}
          multiline
          rows={4}
          required
          error={touched && !reason.trim()}
          helperText={touched && !reason.trim() ? 'Reason is required' : 'Why this contract will not take effect'}
          placeholder="Enter the reason..."
        />
      </Box>
    </Box>
  );
};

export default EmployeeVoidContract;
